// src/pages/user/staff/ChangeUserRoleModal.jsx
import React, { useState } from 'react';
import axiosInstance from '../api/axiosInstance';
import './Modal.css'; // Create styles for your modal if needed

const ChangeUserRoleModal = ({ user, onClose, onRoleUpdated, availableRoles, hotelId }) => {
  const [selectedRoleId, setSelectedRoleId] = useState(user.role?.roleId || '');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleRoleChange = (e) => {
    setSelectedRoleId(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedRoleId) {
      setErrorMessage('Please select a role.');
      return;
    }
    setIsLoading(true);
    try {
      const payload = { userId: user.userId, roleId: Number(selectedRoleId), hotelId };
      const response = await axiosInstance.put(`/User/ChangeRole`, payload);
      if (response.status === 200) {
        onRoleUpdated();
      }
    } catch (error) {
      setErrorMessage('Failed to update role.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Change User Role</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="role-select">Select Role</label>
            <select
              id="role-select"
              value={selectedRoleId}
              onChange={handleRoleChange}
              required
            >
              <option value="">Select Role</option>
              {availableRoles.map(role => (
                <option key={role.roleId} value={role.roleId}>{role.roleName}</option>
              ))}
            </select>
          </div>
          {errorMessage && <p className="error-message">{errorMessage}</p>}
          <div className="button-group">
            <button type="submit" disabled={isLoading}>Update Role</button>
            <button type="button" onClick={onClose}>Cancel</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChangeUserRoleModal;
